<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
  >
    <a-form
      ref="formRef"
      :model="formState"
      :rules="rules"
      :label-col="{ style: { width: '100px' } }"
      ><a-form-item label="生产批号" name="batchNumber">
        <a-input
          v-model:value="formState.batchNumber"
          placeholder="生产批号"
        ></a-input>
      </a-form-item>
      <a-form-item label="备注" name="notes">
        <a-input v-model:value="formState.notes" placeholder="备注"></a-input>
      </a-form-item>
      <a-form-item label="输出编号" name="outputNumber">
        <a-input
          v-model:value="formState.outputNumber"
          placeholder="输出编号"
        ></a-input>
      </a-form-item>
      <a-form-item label="生产日期" name="produceDate">
        <a-date-picker
          v-model:value="formState.produceDate"
          placeholder="生产日期"
        ></a-date-picker>
      </a-form-item>
      <a-form-item label="工序" name="type">
        <a-input v-model:value="formState.type" placeholder="工序"></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { defineComponent, reactive, ref, watch } from "vue";
import { Toast } from "@/utils";
export default defineComponent({
  setup(props, context) {
    const formState = reactive({
      batchNumber: null,
      materialRequisitionDetailList: null,
      notes: null,
      outputNumber: null,
      produceDate: null,
      produceOrTpc: null,
      type: null,
    });
    const rules = {
      batchNumber: [{ required: true, message: null, trigger: "change" }],
      materialRequisitionDetailList: [
        { required: true, message: null, trigger: "change" },
      ],
      notes: [{ required: true, message: null, trigger: "change" }],
      outputNumber: [{ required: true, message: null, trigger: "change" }],
      produceDate: [{ required: true, message: null, trigger: "change" }],
      produceOrTpc: [{ required: true, message: null, trigger: "change" }],
      type: [{ required: true, message: null, trigger: "change" }],
    };
    const modalConfig = reactive({
      visible: false,
      title: null,
    });

    const showModal = (type, options) => {
      const { title, data } = options;
      if (type === "update") {
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }
      if (type === "insert") {
      }
      modalConfig.title = title;
      modalConfig.visible = true;
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.title = null;
      modalConfig.visible = false;
    };

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formRef.value.clearValidate();
    };

    const handleOk = () => {
      formRef.value
        .validateFields()
        .then((res) => {
          updateMaterialRequisition(formState).then((res) => {
            const type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            handleCancel();
            context.emit("handleUpdateTable");
          });
        })
        .catch((err) => {
          if (err && err.errorFields) {
            const [errText] = err.errorFields[0].errors;
            Toast("warning", errText, 3);
          }
        });
    };

    return {
      formState,
      rules,
      showModal,
      handleCancel,
      handleOk,
      modalConfig,
    };
  },
});
</script>
    